/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, IconButton, Tooltip, Box, ListItemSecondaryAction, LinearProgress, Icon } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import RolesDialog from './RolesDialog';
import { setAllRoles } from '../../../redux/slices/roles/roles';
import { setAllPermissions } from '../../../redux/slices/permissions/permissions';

const styles = {
	box: {
		border: "1px solid lightgrey",
		padding: "3rem",
		width: "100%",
		marginTop: "2em",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	slide: {
		width: "200px",
		height: "200px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: "2em",
		border: "1px solid lightgrey",
		padding: "10px"

	},
	img: {
		width: "100%",
		margin: "auto"
	},
	slider: {
		display: "flex",
		alignItems: "center",

	}

};

const Roles = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, } = colors;

	const { roles } = useSelector((state) => state?.roles);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [modalName, setModalName] = useState("");
	const fileInputRef = useRef(null);
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		question: '',
		answer: '',
		type: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalItems: 0,
	});
	const [userRules, setUserRules] = useState([]);
	const [dialogData, setDialogData] = useState({
		enabled: false,
		id: '0',
		name: '',
		description: '',
		permission: []
	});
	// const [currentRules, setCurrenconsumertRules] = useState(dialogData?.rule_set);


	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false)
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getRoles = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.roles?.get, {
				"limit": limit || 10,
				"page": page || 1,
				"columns": "*",
				"sortby": "ASC",
				"orderby": "id",
				"where": "displayed = $1",
				"values": true
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllRoles(
							response?.data?.data?.list?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								client_id: d?.client_id,
								description: d?.description,
								dt: d?.dt,
								name: d?.name,
								enabled: d?.enabled,
								displayed: d?.displayed,
								permissions: d?.permissions,
							})
							),
						),
					);
					const { page, limit, totalPages, totalItems } = response?.data?.data?.list;
					setCurrentParams({ page, limit, totalPages, totalItems });
					setIsLoading(false)
				})
				.catch((error) => {
					console.log(error)
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			console.log(err)
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};
	const getPermissions = async () => {
		try {

			await Api.post(endPoints?.permissions?.get, {
				"limit": 25,
				"page": 1,
				"columns": "*",
				"sortby": "ASC",
				"orderby": "id",
				"where": "displayed = $1",
				"values": true
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPermissions(
							response?.data?.data?.list?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.title,
								description: d?.description,
								dt: d?.dt,
								enabled: d?.enabled,
								displayed: d?.displayed,
								rule_set: d?.rule_set,
								consumer: d?.consumer,
								method: d?.method,
							})
							),
						),
					);
				})
				.catch((error) => {
					console.log(error)
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			console.log(err)
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};


	const handleDeletePermission = async () => {

		try {

			await Api.post(endPoints?.faqs?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Faq Deleted Successfully")
					handleCloseDeleteModal();
					getRoles();

				})
				.catch((error) => {

				});

		} catch (err) {
			console.log(err)
		}
	};
	const handleCreateModal = () => {
		setDialogData({
			enabled: false,
			id: '0',
			name: '',
			description: '',
			permission: []
		})
		setOpenModal(true)
		setIsEditing(false);

	};
	const handleEditModal = (val) => {
		// setIsEditing(true);
		// setFormData({ question: val.question, answer: val.answer, type: val.type, creator_id: val.creator_id, id: val.id })
		// setOpenModal(true)
	};


	const handleOpenDeleteModal = (val) => {
		// setFormData({ id: val.id })
		// setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		// setFormData({ question: '', answer: '', type: '' })
		// setOpenDeleteModal(false)
	};



	useEffect(() => {
		getRoles();
		getPermissions();
	}, [])


	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Name',
			field: 'name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.name}</h4>,
		},

		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{rowData.description}</h4>,
		},
		{
			title: 'Enabled',
			field: 'enabled',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.enabled ? <Icon color='success' className="text-green text-16">check_circle</Icon> : <Icon className="text-red text-16">cancel</Icon>}</h4>,
		},
		// {
		// 	title: 'Date',
		// 	field: 'dt',
		// 	render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format('DD-MM-YYYY')}</h4>,
		// },
		// {
		// 	title: 'Edit',
		// 	field: 'edit',
		// 	filtering: false,
		// 	render: (rowData) => (
		// 		<Tooltip title='Edit'>
		// 			<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
		// 				<EditIcon />
		// 			</IconButton>
		// 		</Tooltip>
		// 	),
		// },
		// {
		// 	title: 'Delete',
		// 	field: 'delete',
		// 	filtering: false,
		// 	render: (rowData) => (
		// 		<Tooltip title='Delete'>
		// 			<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
		// 				<DeleteIcon />
		// 			</IconButton>
		// 		</Tooltip>
		// 	),
		// },

	];

	function handleClick(n) {
		setDialogData({
			enabled: n.enabled,
			id: n.id,
			name: n.name,
			description: n.description,
			permission: n.permissions
		})
		setOpenModal(true);
		setIsEditing(true);
	}


	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>




				<RolesDialog
					isOpen={openModal}
					handleCloseModal={handleCloseModal}
					type="Update"
					data={dialogData}
					setDialogData={setDialogData}
					isEditing={isEditing}
					getRoles={getRoles}
				/>




				{/* <DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDeletePermission}
				/> */}



				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={roles?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Roles"
						showToolbar={true}
						onClickRow={(n) => handleClick(n)}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getRoles(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalItems}
						handlePageChange={(event, newPage) => getRoles(currentParams.limit, newPage + 1)}
						curPage={currentParams.page -1}

					/>
				}







			</Card>
		</>
	);
};

export default Roles;
